import { crudActions, crudMutations, crudGetters } from "@/utils/store";

export const state = () => ({
  objects: [],
  total: 0
})

export const mutations = { ...crudMutations }

export const actions = { ...crudActions('/admin/properties/', '/public/properties/') }

export const getters = { ...crudGetters }
